import {
    IAddToOrderTemplateDialogResources,
    IDuplicateItemsWhenAddingToOrderTemplateDialogResources,
    IItemAddedToOrderTemplateDialogResources,
    IOrderTemplateNameDialogResources
} from '@msdyn365-commerce/components';

export function generateAddToOrderTemplateDialogResources(locale: any): IAddToOrderTemplateDialogResources {
    return {
        addToOrderTemplateHeader: locale.addToOrderTemplate.addToOrderTemplateHeader,

        noOrderTemplatesMessage: locale.addToOrderTemplate.noOrderTemplatesMessage,
        noOrderTemplatesDescription: locale.addToOrderTemplate.noOrderTemplatesDescription,

        createAnOrderTemplateButtonText: locale.addToOrderTemplate.createAnOrderTemplateButtonText,
        createNewOrderTemplateButtonText: locale.addToOrderTemplate.createNewOrderTemplateButtonText,
        cancelOrderTemplateCreationButtonText: locale.addToOrderTemplate.cancelOrderTemplateCreationButtonText,

        selectTemplatesText: locale.addToOrderTemplate.selectTemplatesText,
        addToTemplateButtonText: locale.addToOrderTemplate.addToTemplateButtonText,
        lineItemsText: locale.addToOrderTemplate.lineItemsText
    };
}

export function generateOrderTemplateNameDialogResources(locale: any): IOrderTemplateNameDialogResources {
    return {
        orderTemplateHeaderLabel: locale.addToOrderTemplate.createOrderTemplateHeader,
        orderTemplateTitleLabel: locale.addToOrderTemplate.orderTemplateTitle,
        orderTemplateNameAriaLabel: locale.addToOrderTemplate.orderTemplateNameAriaLabel,
        orderTemplateDescription: locale.addToOrderTemplate.createOrderTemplateDescription,

        defaultOrderTemplateName: locale.addToOrderTemplate.defaultOrderTemplateName,

        orderTemplateButtonLabel: locale.addToOrderTemplate.createOrderTemplateButtonText,
        orderTemplateCancelButtonLabel: locale.addToOrderTemplate.cancelNewOrderTemplateCreationButtonText
    };
}

export function generateItemAddedToOrderTemplateDialogResources(locale: any): IItemAddedToOrderTemplateDialogResources {
    return {
        viewOrderTemplateButtonText: locale.addToOrderTemplate.viewOrderTemplateButtonText,
        continueShoppingButtonText: locale.addToOrderTemplate.continueShoppingButtonText,
        itemAddedToOrderTemplateHeaderItemOneText: locale.addToOrderTemplate.itemAddedToOrderTemplateHeaderItemOneText,
        itemAddedToOrderTemplateHeaderItemFormatText: locale.addToOrderTemplate.itemAddedToOrderTemplateHeaderItemFormatText,
        itemAddedToOrderTemplateHeaderMessageText: locale.addToOrderTemplate.itemAddedToOrderTemplateHeaderMessageText,
        freePriceText: locale.addToOrderTemplate.priceFree,
        originalPriceText: locale.addToOrderTemplate.originalPriceText,
        currentPriceText: locale.addToOrderTemplate.currentPriceText
    };
}

export function generateDuplicateItemsWhenAddingToOrderTemplateDialogResources(
    locale: any
): IDuplicateItemsWhenAddingToOrderTemplateDialogResources {
    return {
        duplicatedProductsHeader: locale.addToOrderTemplate.duplicatedProductsHeader,
        duplicatedProductsDescription: locale.addToOrderTemplate.duplicatedProductsDescription,
        updateQuantityButtonText: locale.addToOrderTemplate.updateQuantityButtonText,
        cancelDuplicateItemsButtonText: locale.addToOrderTemplate.cancelDuplicateItemsButtonText
    };
}
